<obg-common-validation-error
	*ngIf="!!errorKey && isInvalidInput()"
	[testId]="errorKey"
	[errorMessage]="errorKey | jurisdiction | translate: translationArguments"
>
</obg-common-validation-error>
